import { Holiday, HolidaysParams } from '../../models/holidays';
import { httpService } from '../httpService';

const daysOffApiUrl = '/api/DaysOff';

export interface GetHolidaysParams {
  filterDate?: number;
  country?: string;
}

export interface PutHolidayParams {
  id: string;
  dayOffDate: string;
  name?: string;
}

export interface PostHolidayParams {
  name: string;
  dayOffDate: string;
  isDateFixed: boolean;
  country: string;
}

export const getHolidays = async (
  params: HolidaysParams
): Promise<Array<Holiday>> => {
  const response = await httpService.get<Array<Holiday>>(daysOffApiUrl, {
    params,
  });

  return response.data;
};

export const editDayOff = async (params: PutHolidayParams): Promise<void> => {
  await httpService.put(`${daysOffApiUrl}/${params.id}`, params);
};

export const deleteDayOff = async (id: string): Promise<void> => {
  await httpService.delete(`${daysOffApiUrl}/${id}`);
};

export const generateDaysOff = async (): Promise<void> => {
  await httpService.post(`${daysOffApiUrl}/GenerateDaysOff`);
};

export const addDayOff = async (params: PostHolidayParams): Promise<void> => {
  await httpService.post(daysOffApiUrl, [params]);
};
